// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .border {
    border-top: 1px solid ${(props) => props.theme.colors.BORDER.BLUE};
  }
  .remember-me-text {
    ${(props) =>
      !props.isLoginWithOTPEnabled
        ? `font-weight:bold;font-size:${props.theme.typography.fontSizes.fs14};`
        : ''}
  }
  .richTextColor a {
    color: ${(props) => props.theme.colorPalette.red[500]};
  }
  .remember-me-sub-text {
    ${(props) =>
      !props.isLoginWithOTPEnabled
        ? `font-size:${props.theme.typography.fontSizes.fs12};`
        : 'display: block;'}
  }
  .loginShowTop {
    .rightAlignedContent {
      width: 50px;
      right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      font-size: 12px;
      top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      a {
        font-size: 12px;
      }
    }
  }
  .recaptcha_loginotp {
    ${(props) =>
      props.isLoginWithOTPEnabled &&
      `display: flex;
    flex-direction: column;
    align-items: center;`}
  }

  .recaptcha_loginotp .TextBox__error {
    ${(props) =>
      props.isLoginWithOTPEnabled &&
      `margin-top: 5px;
    margin-right: 100px;`}
  }

  .radio_btn_top {
    .radio-button-checked,
    .radio-button {
      ${(props) => props.isLoginWithOTPEnabled && `top: 15px;`}
      @media only screen and (max-width: 430px) {
        ${(props) => props.isLoginWithOTPEnabled && `top: 3px;`}
      }
    }
  }
  .password-container,
  .radio-container {
    ${(props) => props.isLoginWithOTPEnabled && `margin-left: -10px`}
  }
  .password-container {
    .TextBox__input {
      padding: 16px 15px;
    }
  }
  .remember-check {
    ${(props) => props.isLoginWithOTPEnabled && `margin-top: -10px;margin-left: 30px;`}
  }
  .remember-me-checkbox1 {
    ${(props) => props.isLoginWithOTPEnabled && `margin-top: 10px;`}
  }
  .remember-me-check {
    ${(props) => props.isLoginWithOTPEnabled && ` margin: 16px 0 24px`}
  }
  .forget-password-wrapper {
    ${(props) =>
      props.isLoginWithOTPEnabled &&
      `display: flex;
    justify-content: flex-end;`}
  }

  .sms-terms {
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 0
      ${(props) => props.theme.spacing.ELEM_SPACING.XS}
      ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
  }

  .remember-check .CheckBox__input,
  .sms-terms .CheckBox__input {
    ${(props) =>
      props.isLoginWithOTPEnabled &&
      `height: 20px;
    width: 20px;
    &:before {
      border: 1px solid #1a1a1a;
      border-radius: 4px;
    }
    &:after {
      left: 8px;
      top: 3px;
    }`}
  }
  .hidden-field {
    ${(props) => props.isLoginWithOTPEnabled && 'display:none'}
  }
  .resend-email-link {
    font-size: ${(props) => props.theme.typography.fontSizes.fs13};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  }
`;

export default styles;
